import React from 'react';
import moment from 'moment';

import sy from '~/styles';
import {Text, Pressable} from '~/components/controls';
import PropTypes from 'prop-types';

const isClosed = ({availability, selectedDealers, date}) =>
  selectedDealers
    ?.map((dealer_id) => {
      if (!availability) {
        return false;
      }

      const dealer_availability = availability[dealer_id];
      const day_availability = dealer_availability?.[date.format('YYYY-MM-DD')];
      if (!day_availability) {
        return false;
      }

      return day_availability?.capacity <= 0 || day_availability?.is_weekend;
    })
    .every(Boolean);

const Day = ({selected, date, availability, selectedDealers, onChangeDate}) => {
  const closed = isClosed({availability, selectedDealers, date});

  let style;
  let textStyle;
  if (date.isSame(moment(), 'day')) {
    style = {
      backgroundColor: 'rgba(41, 7, 227, 0.1)',
    };
  }

  if (selected) {
    style = {
      backgroundColor: '#231fda',
    };

    textStyle = {
      color: '#ffffff',
    };
  }

  if (closed) {
    textStyle = {
      ...textStyle,
      textDecorationLine: 'line-through',
    };
  }

  return (
    <Pressable
      style={{
        width: 40,
        height: 40,
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 90,
        ...style,
      }}
      onPress={() => onChangeDate(date.clone().add(12, 'H'))}>
      <Text style={[sy.mediumBold, {fontSize: 14}, textStyle]}>
        {date.format('D')}
      </Text>
    </Pressable>
  );
};
Day.propTypes = {
  selected: PropTypes.any,
  date: PropTypes.any,
  availability: PropTypes.any,
  selectedDealers: PropTypes.any,
  onChangeDate: PropTypes.any,
};

export {isClosed};
export default Day;
